export enum WishlistServiceEventType {
	WISHLIST_SERVICE_READY = 'WishlistServiceReady',
	WISHLIST_SYNCED = 'WishlistSynced',
}
